import { render, staticRenderFns } from "./TagsWrapper.vue?vue&type=template&id=5dba98f9&scoped=true&"
import script from "./TagsWrapper.vue?vue&type=script&lang=js&"
export * from "./TagsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TagsWrapper.vue?vue&type=style&index=0&id=5dba98f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba98f9",
  null
  
)

export default component.exports